import { PureComponent } from "react";
import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";

function noop() {}

export default class ActionButton extends PureComponent {
  static propTypes = {
    customHeight: PropTypes.string,
    customWidth: PropTypes.string,
    children: PropTypes.any,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    equalPadding: PropTypes.bool,
    className: PropTypes.string,
    tabIndex: PropTypes.number,
    listenKey: PropTypes.string,
    autofocus: PropTypes.bool,
    id: PropTypes.string,
    dataCy: PropTypes.string,
    customBorderRadius: PropTypes.string,
    minWidth: PropTypes.string,
  };

  static defaultProps = {
    onClick: noop,
    className: "",
    autofocus: false,
    id: "",
  };

  hasKeyListener = false;

  componentDidMount() {
    if (this.props.listenKey) {
      this.hasKeyListener = true;
      window.addEventListener("keypress", this.handleKey);
    }
  }

  componentWillUnmount() {
    if (this.hasKeyListener) {
      window.removeEventListener("keypress", this.handleKey);
    }
  }

  handleKey = e => {
    if (this.props.disabled) {
      return;
    }
    if (e.key === this.props.listenKey) {
      this.props.onClick(e);
    }
  };

  render() {
    return (
      <ButtonStyled
        className={this.props.className}
        autoFocus={this.props.autofocus}
        tabIndex={this.props.tabIndex}
        disabled={this.props.disabled}
        minWidth={this.props.minWidth}
        onClick={this.props.onClick}
        height={this.props.customHeight || "46px"}
        // width="100px"
        customWidth={this.props.customWidth}
        // fullWidth={this.props.fullWidth}
        equalPadding={this.props.equalPadding}
        type="button"
        customBorderRadius={this.props.customBorderRadius}
        id={this.props.id}
        data-cy={this.props.dataCy}
      >
        {this.props.children}
      </ButtonStyled>
    );
  }
}

function padding({ equalPadding }) {
  let result = "";

  if (equalPadding) {
    result += "padding-left: 15px;";
    result += "padding-right: 15px;";
  } else {
    result += "padding-left: 30px;";
    result += "padding-right: 30px;";
  }

  return result;
}

function border({ theme, disabled }) {
  return css`
    border: 1px solid ${disabled ? theme.disabledColor : theme.buttonBorder};
  `;
}
const ButtonStyled = styled.button`
  line-height: normal;
  height: ${({ height }) => height};
  background-color: #fff;
  ${border};
  font-weight: ${({ theme }) => theme.fontWeight.light};

  ${({ theme, disabled }) => !disabled && theme.boxShadow};

  color: ${({ disabled, theme }) =>
    disabled ? theme.disabledColor : theme.buttonColor};
  ${padding};
  border-radius: ${({ customBorderRadius }) =>
    customBorderRadius ? `${customBorderRadius}` : `10px`};
  font-size: 18px;

  outline: none;
  transition: background-color 0.3s, border-color 0.3s;

  ${({ disabled, theme }) =>
    !disabled &&
    css`
      &:hover {
        background-color: ${theme.hoverColor};
        color: ${theme.buttonHoverColor};
        cursor: pointer;
      }
      &:focus {
        background-color: ${theme.hoverColor};
        color: ${theme.buttonHoverColor};
        cursor: pointer;
        border-color: ${theme.borderColor};
      }
    `};
`;
